const MAXZOOM = 20;

export default MAXZOOM;
